import React from 'react';
import { KeyRound } from 'lucide-react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardSubtitle,
  FormGroup,
  FormSpace,
  Label,
  InputGroup,
  InputIcon,
  Input,
  Button
} from './TeacherJourneyStyles';

interface OtpVerificationProps {
  otp: string;
  onOtpChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onVerify: () => void;
  onResend: () => void;
  loading: boolean;
  email: string;
}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  otp,
  onOtpChange,
  onVerify,
  onResend,
  loading,
  email
}) => {
  const handleVerify = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    if (otp.length === 6 && !loading) {
      onVerify();
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Verify Your Email</CardTitle>
        <CardSubtitle>Enter the verification code we sent to {email}</CardSubtitle>
      </CardHeader>

      <FormSpace>
        <form onSubmit={handleVerify}>
          <FormGroup>
            <Label htmlFor="otp">Verification Code</Label>
            <InputGroup>
              <InputIcon>
                <KeyRound size={20} />
              </InputIcon>
              <Input
                type="text"
                name="otp"
                id="otp"
                value={otp}
                onChange={onOtpChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                placeholder="Enter 6-digit code"
                maxLength={6}
                pattern="[0-9]*"
                inputMode="numeric"
                required
                autoComplete="off"
              />
            </InputGroup>
          </FormGroup>

          <Button
            type="submit"
            disabled={loading || otp.length !== 6}
          >
            {loading ? 'Verifying...' : 'Verify Code'}
          </Button>
        </form>

        <Button
          onClick={onResend}
          disabled={loading}
          style={{ backgroundColor: '#f3f4f6', color: '#4b5563' }}
        >
          Resend Code
        </Button>
      </FormSpace>
    </Card>
  );
};

export default OtpVerification; 